/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-namespace */
import * as React from 'react';
import styled from '@emotion/styled';
import { DefaultLabelModel } from './DefaultLabelModel';

export interface DefaultLabelWidgetProps {
    model: DefaultLabelModel;
}

namespace S {
    export const Label = styled.div`
        color: white;
        font-size: 25px;
        margin: 16px;
        user-select: none;
        font-family: "Roboto","Helvetica","Arial",sans-serif;
        padding: 10px;
        line-height: 1.4 !important;
        word-wrap: break-word;
        font-weight: 700;
        border-radius: 4px;
        background-color: black;
        border: 2px solid #5A5A5A;
        ul {
            list-style: square;
            margins: 0px;
            padding-left: 40px;
        }
    `;
}

export class DefaultLabelWidget extends React.Component<DefaultLabelWidgetProps> {
  render() {
    return <S.Label className={`tooltip-item ${this.state}`}>{this.props.model.getOptions().label}</S.Label>;
  }
}
